<template>
	<div class="box">
        
        <el-aside style="height: 100%;width: 100%;"> <MenuIndex/></el-aside>
        <el-form :inline="true" :model="form" class="demo-form-inline">
            <el-form-item label="发送数据">
                <el-input v-model="form.data" placeholder="加密数据" :rows="20"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">发送</el-button>
            </el-form-item>
            </el-form>
        
	</div>

</template> 

<script>
import {Form, Message} from 'element-ui';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import MenuIndex from '../views/chatgpt/menu_index.vue';

export default{

name:"Testsocket",
    components: {MenuIndex},
    data(){
        return {
            title:"人工智能",
            socket:null,
            stompClient:null,
            form: {
                data: 'D/lPgUjU2/tlnWQbn5XZTC8m3xhEm7lfQIEFdNcORVAifAt9bpCkYzMVFb3rhAB9bTnCtfF6SiMprZdbGRi60YzWTiye/KZRcU3G6chD7BTVeQMIpOMvI2TTGxzGG9ZihjZbciv5XfEsz1mzAb+hI770Ib+vzdxL3uvNV1b6mog='
            }
        }
    },
    methods:{
		handleClick(tab, event) {
			console.log(tab, event);
		},
   
        //初始化
            initWebSocket(){
                
                this.connection();

            },
            //建立连接
            connection() {
                console.log('正在连接')
                // 建立连接对象
                //连接服务端提供的通信接口，连接以后才可以订阅广播消息和个人消息
                let _that=this;
                //后台服务ip和porthttps://apitest.hooply.com
                //_that.socket = new SockJS('http://localhost:8001/ws/ep?token=NE2DCUZLMVEFMML2LE6Q');
             //   _that.socket = new SockJS('http://localhost:8001/ws/ep?token=JZDFSRZSJZGFGSCCKNLEWNSUJJEVMRSYIMZUWV2KLJLUMRZSIJJUWWJTKZJVASI');
             //   _that.socket = new SockJS('https://cateyetest.hooply.net/ws/ep?token=JZDFSRZSJZGFGSCCKNLEWNSUJJEVMRSYIMZUWV2KLJLUMRZSIJJUWWJTKZJVASI');
              //_that.socket = new SockJS('https://apitest.hooply.com/ws/ep');
                // 获取STOMP子协议的客户端对象
              //  _that.stompClient = Stomp.over(_that.socket);
              _that.stompClient = Stomp.over('wss://cateyetest.hooply.net/ws/ep?token=NFYG2NLSGVJGI6TKNQ2XC3KVGVWFG2BSKY4TIPI');
                // _that.stompClient.debug = null 
                _that.stompClient.connect({}, success => {
            
            
                    _that.stompClient.subscribe('/user/topic/lock/state', msg => {
                        console.log("msg:",msg)
                    
                    })
                }, error => {
                    console.log("连接失败："+error)
                });
            },
            disconnect() {
                if (this.stompClient != null) {
                    this.stompClient.disconnect();
                 
                }
            },
            onSubmit() {
                this.stompClient.send('/ws/send/lock/state', {}, this.form.data);
            },
       
        //销毁页面之前，断开连接
        beforeDestroy: function () {
            //页面离开时断开连接,清除定时器
            //this.disconnect();
            clearInterval(this.timer);
        },
        mounted(){
            //调用初始化websocket方法
            this.initWebSocket();
        },
       
        addMessage() {
               
                    let msgObj = new Object();
                    msgObj.toUserId =  this.phone;
                  //  msgObj.fromUserPhone = 18313975762;
                    msgObj.chatMsg = this.content;
                  
                    this.stompClient.send('/ws/chat', {}, JSON.stringify(msgObj));
             
            },
             //getMsg(){
            //    this.stompClient.subscribe('/user/queue/chat', msg => {
            //        let receiveMsg = JSON.parse(msg.data);
                   
             //       console.log("receiveMsg："+receiveMsg)
          //  })
       // },
        detail(){
             this.postRequest('/user/info',self.params).then(resp =>{
                 self.loadingButton=false;
                 self.loadingButtonText='去你的吧';
                  window.sessionStorage.setItem("user", JSON.stringify(resp.data.phone));
                  console.log("this.username:"+this.username);
            })
        },
        loginAnonymous(){
             this.postRequest('/user/login_anonymous',self.params).then(resp =>{
                 self.loadingButton=false;
                 self.loadingButtonText='去你的吧';
                window.sessionStorage.setItem("user", JSON.stringify(resp.data.phone));
                console.log("this.username:"+this.username);
                console.log("resp.error:"+resp.err);
                if(resp.err === 0){
                    this.initWebSocket();
                }
                  
            })
        }
    },
    
    created() {
      //  this.loginAnonymous();
      this.initWebSocket();
     // window.localStorage.setItem('aaa',2)
    //this.userId = window.localStorage.getItem('aaa');
    },
    //destroyed() {
      //this.websock.close();//离开路由之后断开websocket连接
    //}
}
</script>
<style>
	.box{

       
      /* 水平垂直居中 */
      margin: 10px 80px auto;

	}
</style>